<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Cuotas",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
};
</script>
<template>
  <Layout>
    <div classs="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">Cuotas de renting</h4>
            </b-row>
            <p><b> Estimado cliente,</b></p>
            <p><b>Actualmente usted  no tiene contratado este servicio. Por favor ponerse en contacto con su ejecutivo al número 22 360 8600.</b></p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
</style>